import React, { useEffect, useState } from "react";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import ReactPortal from "Components/ReactPortal/ReactPortal";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import api from "http";
import { toast } from "react-toastify";
import Validator, {
  ValidationTypes as V_Type,
} from "react-form-supervalidator";
import ParamListGen from "Services/ParamListGen";
import PatientSearchGrid from "MainTabs/Patients/PatientSearch/PatientSearchGrid";
import ChargesSearchGrid from "MainTabs/Charges/ChargesSearch/ChargesSearchGrid";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";
import PatientSearchForm from "MainTabs/Patients/PatientSearch/PatientSearchForm";
import UseZipCode from "CustomHooks/UseZipCode";
import useFilterCount from "CustomHooks/useFilterCount";
import ChargesSearchForm from "MainTabs/Charges/ChargesSearch/ChargesSearchForm";
import useDebounce from "CustomHooks/useDebounce";
import PopupFooter from "Components/PopupFooter/PopupFooter";
import CustomDraggable from "Common/CustomDraggable/CustomDraggable";
import PopupHeader from "Components/PopupHeader/PopupHeader";

const searchModelClaim = {
  patientId: "",
  visitType: "P",
  isSubmitted: "",
  dosFrom: "",
  dosTo: "",
  SubmittedDateFrom: "",
  SubmittedDateTo: "",
  claimStatusCode: "",
  entryDateFrom: "",
  entryDateTo: "",
  visitId: "",
  tabName: "All",
  entryDateType: "dateOfEntry",
  providerId: "",
  locationId: "",
  posCode: "",
  insurancePlanId: "",
};

const searchModelPatient = {
  patientId: "",
  accountNum: "",
  lastName: "",
  firstName: "",
  dob: "",
  ssn: "",
  gender: "",
  address: "",
  city: "",
  state: "",
  zipCode: "",
  dateFrom: "",
  dateTo: "",
  mergedToPatientId: "",
  patientStatus: "active",
  primaryPayer: "",
  secondaryPayer: "",
  creditAmount: "0",
  balanceAmount: "0",
  creditCondition: "Over",
  balanceCondition: "Over",
  tag: "",
  // legacy fields retained for compatibility if referenced elsewhere
  address1: "",
  address2: "",
};
const paginationModel = {
  param_list: [],
  practiceId: 0,
  perPage: 20,
  pageNo: 1,
  totalPages: 0,
  totalCount: 0,
  isExportCall: false,
};
const TaskLinkPopup = ({ onClose, linkType, allLinks, onChangeLink }) => {
  const [patientsList, setPatientsList] = useState([]);
  const [claimsList, setClaimsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(paginationModel);
  const [superSearchValue, setsuperSearchValue] = useState("");
  const [superSearchPayerValue, setSuperSearchPayerValue] = useState("");
  const [patientSuperSearchId, setPatientSuperSearchId] = useState("")

  const [searchModel, setSearchModel] = useState(linkType.type === "Patient" ? searchModelPatient : searchModelClaim);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [taskRowsData, setTaskRowsData] = useState([]);
  const [superVisitValue, setSuperVisitValue] = useState("");
  const [validationModelPatient, setValidationModelPatient] = useState({
    zipCodeError: null,
  });
  const [validationModelClaim, setValidationModelClaim] = useState({
    entryDateFromError: null,
    dosFromError: null,
    SubmittedDateFromError: null
  })
  const debouncedSearchTerm = useDebounce(superVisitValue, 500);
  const { onPasteZip } = UseZipCode(
    setSearchModel,
    setValidationModelPatient,
    searchModel.zipCode
  );
  const { filterCount, calculateCount } = useFilterCount();
  const setValidation = () => {
    let validationObj = {
      ...validationModelClaim,
      entryDateFromError: Validator([searchModel.entryDateFrom, searchModel.entryDateTo], [V_Type.startEndDate], ['Entry date from should be Less or Equal To Entry date to'],),
      dosFromError: Validator([searchModel.dosFrom, searchModel.dosTo], [V_Type.startEndDate], ['DOS from date should be Less or Equal To DOS to date'],),
      SubmittedDateFromError: Validator([searchModel.SubmittedDateFrom, searchModel.SubmittedDateTo], [V_Type.startEndDate], ['Submitted date from should be Less or Equal To Submitted date to'],),

    }
    setValidationModelClaim(validationObj)
    return Validator(validationObj, V_Type.NullCheck);
  }

  const handleAddNewLink = (val) => {
    const isLinkExist =
      linkType.type === "Patient"
        ? allLinks.some((link) => link.patientId === val.id)
        : allLinks.some((link) => link.claimId === val.visitId);
    if (isLinkExist) {
      toast.info("Link already exist");
    } else {
      let descp = "";
      if (linkType.type === "Patient") {
        descp = `${val.firstName} Account# (${val.accountNum})`;
      } else {
        descp = `Claim(#${val.visitId}) Follow up for ${val.patientName}`;
      }
      const obj = {
        addedBy: "",
        inActive: false,
        taskId: 0,
        id: 0,
        linkTypeId: linkType.linkTypeId,
        type: linkType.type,
        description: descp,
        patientId: linkType.type === "Patient" ? val.id : 0,
        claimId: linkType.type === "Claim" ? val.visitId : 0,
        paymentMainId: 0,
      };
      const newLinks = [...allLinks, obj];
      onChangeLink(newLinks);
    }
  };
  const handleFilterSuperSearch = (e) => {
    setSuperVisitValue(e.target.value)
  }
  const handleSubmit = async (pageNo, perPage) => {
    let myValidation = setValidation();
    if (!myValidation) {
      setIsLoading(true);
      try {
        const paramList = ParamListGen(searchModel);
        const payload = {
          param_list: paramList,
          practiceId: 0,
          perPage,
          pageNo,
          totalPages: 0,
          totalCount: 0,
          isExportCall: false,
        };
        const response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisit`, payload);
        const dataModel = response.data.dataModel;
        setClaimsList(dataModel.gridData.data);
        setPagination(prev => ({ ...prev,
           totalCount: dataModel.gridData.totalCount ,
           perPage: dataModel.gridData.perPage,
           pageNo: dataModel.gridData.pageNo,
          }));
        calculateCount(paramList, searchModelClaim);
      } catch (error) {
        ErrorHandlingMessage(error);  
        setPatientsList([]);
        setClaimsList([]);
      } finally {
        setIsLoading(false);
      }
    }
  }

  const handleClear = async () => {
    setIsLoading(true);
    setSearchModel(searchModelClaim);
    setsuperSearchValue("")
    try {
      const paramList = ParamListGen(searchModelClaim);
      const payload = {
        ...paginationModel,
        param_list: paramList,
        practiceId: 0,
        isExportCall: false,
      };
      const response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisit`, payload);
      const dataModel = response.data.dataModel;
      setClaimsList(dataModel.gridData.data);
      setPagination(prev => ({ ...prev,
         totalCount: dataModel.gridData.totalCount ,
         perPage: dataModel.gridData.perPage,
         pageNo: dataModel.gridData.pageNo,
        }));
      calculateCount(paramList, searchModelClaim);
    } catch (error) {
      ErrorHandlingMessage(error);
      setPatientsList([]);
      setClaimsList([]);
    } finally {
      setIsLoading(false);
    }
  };



  const handleSearchModel = (e) => {
    const { name, value } = e.target;
    setSearchModel(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAllSelected = () => {
    let allSelectedLinks = [...allLinks];
    taskRowsData.forEach((row) => {
      const isLinkExist =
        linkType.type === "Patient"
          ? allLinks.some((link) => link.patientId === row.patientId)
          : allLinks.some((link) => link.claimId === row.visitId);
      if (isLinkExist) {
        toast.info("Link already exist");
      } else {
        let descp = "";
        if (linkType.type === "Patient") {
          descp = `${row.patientName} Account# (${row.accountNum})`;
        } else {
          descp = `Claim(#${row.visitId}) Follow up for ${row.patientName}`;
        }
        const obj = {
          addedBy: "",
          inActive: false,
          taskId: 0,
          id: 0,
          linkTypeId: linkType.linkTypeId,
          type: linkType.type,
          description: descp,
          patientId: linkType.type === "Patient" ? row.patientId : 0,
          claimId: linkType.type === "Claim" ? row.visitId : 0,
          paymentMainId: 0,
        };
        allSelectedLinks.push(obj);
      }
    });

    onChangeLink(allSelectedLinks);
  };

  const handleRowSelection = (idsList) => {
    let selectedRowsInfo = [];
    setSelectedRows(idsList);
    if (linkType.type === "Patient") {
      idsList.forEach((id) => {
        patientsList.forEach((el) => {
          if (el.id === id)
            selectedRowsInfo.push({
              patientId: el.id,
              patientName: `${el.lastName},${el.firstName}`,
              accountNum: el.accountNum,
            });
        });
      });
    } else {
      idsList.forEach((id) => {
        claimsList.forEach((el) => {
          if (el.id === id)
            selectedRowsInfo.push({
              visitId: el.visitId,
              patientName: el.patientName,
            });
        });
      });
    }

    setTaskRowsData(selectedRowsInfo);
  };
  const handleSearchPatient = async (status, pageNo = 1, perPage = 20) => {
    if (status === "cancel") {
      setSearchModel(searchModelPatient);
      setValidationModelPatient({ zipCodeError: null });
      setSelectedRows(new Set());
    }
    let myValidation = Validator(validationModelPatient, V_Type.NullCheck);
    if (myValidation === false) {
      try {
        setIsLoading(true);
        let paramList = ParamListGen(
          status === "cancel" ? searchModelPatient : searchModel
        );
        let payload = {
          param_list: paramList,
          practiceId: 0,
          perPage,
          pageNo,
          totalPages: 0,
          totalCount: 0,
          isExportCall: false,
        };
        const response = await api.post(
          `${process.env.REACT_APP_TC_PMS}/api/Patient/FindPatient`,
          payload
        );
        setPatientsList(response.data.dataModel.data);
        setPagination((prev) => ({
          ...prev,
          pageNo: response.data.dataModel.pageNo,
          perPage: response.data.dataModel.perPage,
          totalCount: response.data.dataModel.totalCount,
        }));
        setValidationModelPatient({ zipCodeError: null });
        calculateCount(paramList, searchModelPatient);
      } catch (error) {
        toast.error(error.response.data.responseMessage);
      } finally {
        setIsLoading(false);
      }
    }
  };
  const handleEnterPatient = (e) => {
    if (e.charCode === 13) {
      handleSearchPatient("", 1, 20);
    }
  };

  const handlePageChange = (pageNo) => {
    setPagination(prev => ({ ...prev, pageNo }));
    if (linkType.type === "Patient") {
      handleSearchPatient("", pageNo, pagination.perPage)
    } else {
      handleSubmit(pageNo, pagination.perPage)
    }
  };
  const handlePerRowsChange = (perPage, pageNo) => {
    setPagination((prev) => ({ ...prev, pageNo, perPage }))
    if (linkType.type === "Patient") {
      handleSearchPatient("", pageNo, perPage)
    } else {
      handleSubmit(pageNo, perPage)
    }
  };
  const handlemultiSelectChange = (selectedOptions, key) => {
    let dsf = selectedOptions ? selectedOptions.map(opt => opt.value).join(",") : ""
    setSearchModel((prev) => ({ ...prev, [key]: dsf }));
  };
  const handleChange = (e) => {
    const { type, value, checked, name } = e.target;

    if (name === "entryDateType") {
      setSearchModel({
        ...searchModel,
        dosFrom: "",
        dosTo: "",
        entryDateFrom: "",
        entryDateTo: "",
        SubmittedDateFrom: "",
        SubmittedDateTo: "",
        [name]: value,
      });

      setValidationModelClaim({
        entryDateFromError: null,
        dosFromError: null,
        SubmittedDateFromError: null
      })
    } else {
      setSearchModel({
        ...searchModel,
        [name]: type === "checkbox" ? !checked : value,
      });
    }
  };
  const handleSelectedData = (selectedObj, searchName) => {
    if (selectedObj) {
      if (searchName === "Patient") {
        setsuperSearchValue(selectedObj.name);
        setSearchModel((prev) => ({
          ...prev,
          patientId: selectedObj.id
        }))
      } else if (searchName === "Insurance") {
        setSearchModel((prev) => ({
          ...prev,
          insurancePlanId: selectedObj.insurancePlanId,
        }))
        setSuperSearchPayerValue(selectedObj.payerName);
      }

    } else {
      if (searchName === "Patient") {
        setsuperSearchValue("");
        setSearchModel((prev) => ({
          ...prev,
          patientId: ""
        }))
      } else if (searchName === "Insurance") {
        setSearchModel((prev) => ({
          ...prev,
          insurancePlanId: "",
          payerName: "",
        }))
        setSuperSearchPayerValue("");
      }
    }

  }



  useEffect(() => {
    if (debouncedSearchTerm === "" || debouncedSearchTerm.length > 2) {
      (async () => {
        try {
          setIsLoading(true);
          switch (linkType.type) {
            case "Patient":
              const paramModelPatient = {
                ...searchModelPatient,
                patientId: patientSuperSearchId
              };
              const payload = {
                param_list: ParamListGen(paramModelPatient),
                practiceId: 0,
                perPage: 20,
                pageNo: 1,
                totalPages: 0,
                totalCount: 0,
                isExportCall: false,
              };
              const patResponse = await api.post(
                `${process.env.REACT_APP_TC_PMS}/api/Patient/FindPatient`,
                payload
              );
              setPatientsList(patResponse.data.dataModel.data);
              setPagination((prev) => ({
                ...prev,
                totalCount: patResponse.data.dataModel.totalCount,
              }));
              break;
            case "Claim":
              const paramModelClaim = {
                ...searchModelClaim,
                visitId: debouncedSearchTerm
              };
              const claimPayload = {
                ...paginationModel,
                param_list: ParamListGen(paramModelClaim),
                perPage: 20,
                pageNo: 1,
                totalPages: 0,
                totalCount: 0,
              };

              const claimResponse = await api.post(
                `${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisit`,
                claimPayload
              );
              setClaimsList(claimResponse.data.dataModel.gridData.data);
              setPagination((prev) => ({
                ...prev,
                totalCount: claimResponse.data.dataModel.gridData.totalCount,
              }));
              break;
            default:
            // code block
          }
        } catch (error) {
          ErrorHandlingMessage(error);
          setPatientsList([]);
          setClaimsList([]);
        } finally {
          setIsLoading(false);
        }
      })();
    }
  }, [linkType, debouncedSearchTerm, patientSuperSearchId]);

  const UNIQUE_ID = "TaskLinkPopup";
  return (
    <ReactPortal wrapperId={UNIQUE_ID}>
      {isLoading && <FullPageLoader />}
      <div data-te-modal-init className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" aria-modal="true" data-te-open="true">
        <CustomDraggable disableDraggable={false} handle={`#${UNIQUE_ID}`}>
          <div data-te-modal-dialog-ref className="relative w-[1300px]   min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg">
            <div className='p-4 pt-0 '>
              <PopupHeader heading={`Select New ${linkType.type}`} uniqueId={UNIQUE_ID} />
              <div className=" overflow-y-auto max-h-[80vh] p-2">
                <div className="grid grid-cols-12 ">

                  <div className="absolute flex justify-end col-span-7 mt-0.5 right-5">
                    {[...selectedRows].length > 0 ? (
                      <CustomButtonNew
                        onClick={handleAllSelected}
                        variant="outline"
                        label="Link Selected"
                      />
                    ) : null}
                  </div>
                  <div className="col-span-12 ">
                    {linkType.type === "Patient" ? (
                      <>
                        <PatientSearchForm
                          setLoading={setIsLoading}
                          validationModel={validationModelPatient}
                          searchModel={searchModel}
                          handleSearchModel={handleSearchModel}
                          handleEnter={handleEnterPatient}
                          handleSearchPatient={handleSearchPatient}
                          onPasteZip={onPasteZip}
                          setSearchModel={setSearchModel}
                          pagination={pagination}
                          selectedRows={selectedRows}
                          taskRowsData={taskRowsData}
                          filterCount={filterCount}
                          setPatientSuperSearchId={setPatientSuperSearchId}
                          parentTab="tasks"
                          handlemultiSelectChange={handlemultiSelectChange}
                        />

                        <PatientSearchGrid
                          allPatients={patientsList}
                          pagination={pagination}
                          handlePerRowsChange={handlePerRowsChange}
                          handlePageChange={handlePageChange}
                          onPatientClcik={handleAddNewLink}
                          selectedRows={selectedRows}
                          manualPagination={true}
                          selectColumn={true}
                          handleRowSelection={handleRowSelection}
                          parentName="tasks"
                        />

                      </>
                    ) : (
                      <>
                        <ChargesSearchForm
                          handleChange={handleChange}
                          searchModel={searchModel}
                          handleSelectedData={handleSelectedData}
                          superSearchValue={superSearchValue}
                          setsuperSearchValue={setsuperSearchValue}
                          validationModel={validationModelClaim}
                          handleClear={handleClear}
                          handleSubmit={handleSubmit}
                          filterCount={filterCount}
                          superSearchPayerValue={superSearchPayerValue}
                          setSuperSearchPayerValue={setSuperSearchPayerValue}
                          visitLoader={isLoading}
                          handleFilterSuperSearch={handleFilterSuperSearch}
                          superVisitValue={superVisitValue}
                          parentName="tasks"
                        />

                        <ChargesSearchGrid
                          setClaim={handleAddNewLink}
                          rows={claimsList}
                          paramModel={pagination}
                          handlePerRowsChange={handlePerRowsChange}
                          handlePageChange={handlePageChange}
                          handleRowSelection={handleRowSelection}
                          selectedRows={selectedRows}
                          selectColumn={true}
                          parentName="tasks"
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
              <PopupFooter onClose={onClose} />
            </div>
          </div>
        </CustomDraggable>
      </div>
    </ReactPortal>
  );
};
export default TaskLinkPopup;
